import styled, { css } from 'styled-components';

import { Col as BaseColumn } from '@/components/Col';
import { Row } from '@/components/Row';
import { theme } from '@/theme';

export const Wrapper = styled(Row)`
  display: grid;
  ${theme.media.md.down} {
    display: flex;
    flex-direction: column;
    gap: 3rem;
  }
  grid-template-columns: repeat(12, 1fr);
  grid-gap: 10px;
`;

export const ParameterCol = styled(BaseColumn)`
  grid-column: span 12;
  height: 100%;
  margin-top: 30px;
  ${({ theme }) => css`
    ${theme.media.md.up} {
      margin-top: 0;
      grid-column: span 4;
    }
    ${theme.media.md.down} {
      margin-top: 0;
    }
  `}
`;
